import { Outlet } from "react-router-dom";
import { AppLayout } from "@etframework/ui.components";
import useIsMounted from "../hooks/useIsMounted";
import { IconLoading } from "../components/Loading/IconLoading";
import DueDatesAppheader from "./components/DueDatesAppHeader";

//Portals
import Notification from "./portals/Notification";

const NotificationsLayout = () => {
  const isMounted = useIsMounted(true);

  if (!isMounted) return <IconLoading />;

  return (
    <AppLayout className="duedates-settings-layout">
      <AppLayout.Header>
        <DueDatesAppheader />
      </AppLayout.Header>

      <AppLayout.ContentRow>
        <div className="container-fluid">
          <div className="row et-settings-nav">
            <div className="module-layout d-flex flex-fill me-3 mb-3 h-100 mx-4">
              <div className="col">
                <div className="d-flex flex-column h-100 w-100">
                  <Outlet />
                </div>
              </div>
            </div>
          </div>
        </div>
      </AppLayout.ContentRow>
      <AppLayout.Portals>
        <Notification />
      </AppLayout.Portals>
    </AppLayout>
  );
};

export default NotificationsLayout;
